/*
* params
* carrierPrice: final price that is agreed upon after the negotiation process
* totalPrice: if the priceType is per km, total price is calculated by multiplying per km price with total km if there's a distance
*/

import React, { useEffect } from 'react'
import useTransactions from 'tennders-transactions/hooks/useTransactions'
import { GButton, GInput } from 'tennders-common/form/components'
import { capitalizeFirst, gCurrency, getTotalPrice } from 'tennders-stracture/libs/utils'
import { TransactionType } from 'tennders-transactions/types/TransactionType'
import useUpdateBookRate from 'tennders-market/common/hooks/useUpdateBookRate'
import useTranslation from 'next-translate/useTranslation'

interface CarrierCurrencyProps {
    transaction: TransactionType; // TODO: Create transaction interface
    detailsClass?: string;
    withoutDetail?: boolean;
    carrierShipperLabel?: () => JSX.Element;
    editable?: boolean;
    setEditable? : (boolean) =>void;
    isBrokerRowDisplay?: boolean
}

const CarrierCurrencyComponent = (props : CarrierCurrencyProps) => {
  const {
    transaction,
    editable,
    setEditable,
    carrierShipperLabel,
    detailsClass,
    withoutDetail,
    isBrokerRowDisplay
  } = props
  const carrierPrice = gCurrency(transaction?.matchedTruck?.bookRate)
  const totalPrice = getTotalPrice(transaction, transaction.matchedTruck.priceType, transaction?.matchedTruck?.bookRate)
  const { updatePrice: savePrice, saving, setInputPrice, inputPrice } = useUpdateBookRate({
    transaction,
    setEditable
  })
  const { refreshTransaction } = useTransactions()
  const { t } = useTranslation()

  const updatePrice = async () => {
    if (await savePrice('truck')) {
      refreshTransaction()
    }
  }

  useEffect(() => {
    setInputPrice(transaction?.matchedTruck?.bookRate)
  }, [transaction])

  return (
    isBrokerRowDisplay ? (
      <div className="d-flex text-10">
        <img
          src="/img/icon-truck.svg"
          width="24"
          height="24"
          alt="Carrier"
          className="mr-8" />
        <div className="d-flex flex-col">
          <span> {transaction.matchedTruck?.priceType}</span>
          <strong>
            {totalPrice ? (
              <span>
                {carrierPrice}
                {gCurrency(totalPrice) !== carrierPrice && ` (${gCurrency(totalPrice)}) `}
              </span>
            ) : <span>{carrierPrice}</span>}
          </strong>
          <span>{` ${transaction?.matchedTruck?.paymentTerm?.type}`}</span>
        </div>
      </div>
    ) : (
      <> {' '}
        {carrierShipperLabel()}
        {transaction.matchedTruck?.priceType}
        {': '}
        {editable ? (
          <div className="d-flex row ">
            <GInput onSet={setInputPrice} type="currency" val={inputPrice} />
            <GButton
              submitting={saving}
              onClick={updatePrice}
              className="ml-10 mt-8 mb-2 btn standard-btn cursor-pointer medium"
              labelKey="common:save" />
          </div>
        ) : (
          totalPrice ? (
            <span>
              {carrierPrice}
              {gCurrency(totalPrice) !== carrierPrice && ` (${gCurrency(totalPrice)}) `}
            </span>
          ) : carrierPrice
        )}
        {withoutDetail ? <span className="bold positive-text">{` ${capitalizeFirst(transaction?.matchedTruck?.paymentTerm?.type || '')}`}</span> : (
          <>
            <br />
            {t('transaction:paymentTerms')}
            <span className={detailsClass || ''}>
              <>
                {` ${transaction?.matchedTruck?.paymentTerm?.type}`}
                {/* ` / ${transaction?.matchedTruck?.paymentTerm?.dType ? t('common:' + transaction?.matchedTruck?.paymentTerm?.dType) : '-'}` */}
                {` / ${transaction?.matchedTruck?.paymentTerm?.days || '?'} days`}
                {` / ${transaction?.matchedTruck?.paymentTerm?.cmrType?.label || ''}`}
              </>
            </span>
          </>
        )}
      </>
    )
  )
}

export default React.memo(CarrierCurrencyComponent)
